function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16512_203276)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 3.2,
    fill: "#FFC107",
    style: {
      fill: "#FFC107",
      fill: "color(display-p3 1.0000 0.7569 0.0275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 8.48361L2.84375 5.91113V11.0225C2.84446 11.2816 2.94771 11.5299 3.13094 11.7131C3.31417 11.8964 3.56248 11.9996 3.82161 12.0003H12.1833C12.4424 11.9996 12.6907 11.8964 12.874 11.7131C13.0572 11.5299 13.1605 11.2816 13.1612 11.0225V5.96501L8.00016 8.48361Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00475 7.51671L13.1612 5.00002V4.97786C13.1605 4.71873 13.0572 4.47042 12.874 4.28719C12.6907 4.10396 12.4424 4.00071 12.1833 4H3.82161C3.56844 4.0005 3.32528 4.09891 3.14302 4.27462C2.96075 4.45033 2.85352 4.68973 2.84375 4.94271L8.00475 7.51671Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16512_203276"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.9b2663866cb2475838c0eeecc924e0e8.svg";
export { ForwardRef as ReactComponent };